import React from 'react';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import {ROUTES} from "./types";
import Api from './context/axios';
import {
  Landing,
  About,
  Product,
  NotFound,
  SignIn,
  SignUp,
  Applications,
  ClientProduct,
  Statistics,
  ResetPassword,
  ActivateEmail,
  SetNewPassword,
} from "./pages";
import AlertPopup from "./components/common/Alert";
import {PrivateRoute, PublicRoute} from "./components/routes";

const router = createBrowserRouter([
  {
    path: ROUTES.MAIN,
    element: <Landing />
  },
  {
    path: ROUTES.ABOUT_US,
    element: <About />
  },
  {
    path: ROUTES.PRODUCT,
    element: <Product />
  },
  {
    path: ROUTES.ACTIVATE_EMAIL,
    element: <ActivateEmail />
  },
  {
    path: ROUTES.SET_NEW_PASSWORD,
    element: <SetNewPassword />
  },
  {
    path: ROUTES.RESET_PASSWORD,
    element: <ResetPassword />
  },
  {
    path: ROUTES.SIGN_IN,
    element: <PublicRoute component={<SignIn />} />
  },
  {
    path: ROUTES.SIGN_UP,
    element: <PublicRoute component={<SignUp />} />
  },
  {
    path: ROUTES.APPLICATIONS,
    element: <PrivateRoute component={<Applications />} />
  },
  {
    path: ROUTES.CLIENT_PRODUCT,
    element: <PrivateRoute component={<ClientProduct />} />
  },
  // {
  //   path: ROUTES.STATISTICS,
  //   element: <PrivateRoute component={<Statistics />} />
  // },
  {
    path: '*',
    element: <NotFound />
  },
])

const App = () => {
  const queryClient = new QueryClient();

  return (
    <Api queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <AlertPopup />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Api>
  )
};

export default App;
